export function percentage(a: number, b: number, decimals: number = 2): string {
    if (b === 0) {
        return "0%";  // Handle division by zero by returning 0%
    }
    
    const result = (a / b) * 100;

    // Format the percentage with up to the desired number of decimal places
    return result.toLocaleString(undefined, { maximumFractionDigits: decimals }) + "%";
}